import { render, staticRenderFns } from "./property-address.vue?vue&type=template&id=37d9d72d&"
import script from "./property-address.vue?vue&type=script&lang=ts&"
export * from "./property-address.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports